import React, { createContext, useState, useEffect } from 'react'
import axios from 'axios'

export const userContext = createContext({})
export default function Context(props){
  const [user, setUser] = useState()
  useEffect(() => {
    axios.get('/user', {withCredentials: true}).then(res => {
      setUser(res.data)
    })
  }, [])

  return (
    <userContext.Provider value={user}>
      {props.children}
    </userContext.Provider>
  )
}
